import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const DOWNLOAD_CONTENT_REQUEST = "DOWNLOAD_CONTENT_REQUEST";
export const DOWNLOAD_CONTENT_SUCCESS = "DOWNLOAD_CONTENT_SUCCESS";
export const DOWNLOAD_CONTENT_ERROR = "DOWNLOAD_CONTENT_ERROR";

export const downloadPdf = (pdfId, pdfType, clientId, filename = "", language = "S") => {
    return async (dispatch) => {
        try {
            dispatch(downloadContentRequest(pdfId, pdfType));

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/content/pdf', {pdfId, pdfType, clientId, language}, { headers: { 'Authorization': 'Bearer ' + token } });

            await utilsLib.savePdf(res.data.payload, filename || `${pdfId}.pdf`);

            dispatch(utilsLib.response(res, downloadContentSuccess, downloadContentError));
        } catch (err) {
            dispatch(utilsLib.response(err, downloadContentError));
        }
    };
};

export const downloadExcel = (excelId, excelType, clientId) => {
    return async (dispatch) => {
        try {
            dispatch(downloadContentRequest(excelId, excelType));

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/content/excel', {excelId, excelType, clientId}, { headers: { 'Authorization': 'Bearer ' + token } });

            const filename = excelId.replace('.pdf', '') + '.xlsx';
            await utilsLib.saveExcel(res.data.payload, filename);

            dispatch(utilsLib.response(res, downloadContentSuccess, downloadContentError));
        } catch (err) {
            dispatch(utilsLib.response(err, downloadContentError));
        }
    };
};

export const downloadJson = (jsonId, jsonType, clientId) => {
    return async (dispatch) => {
        try {
            dispatch(downloadContentRequest(jsonId, jsonType));

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/content/json', {jsonId, jsonType, clientId}, { headers: { 'Authorization': 'Bearer ' + token } });

            const filename = jsonId.replace('.pdf', '') + '.json';
            await utilsLib.saveJson(res.data.payload, filename);

            dispatch(utilsLib.response(res, downloadContentSuccess, downloadContentError));
        } catch (err) {
            dispatch(utilsLib.response(err, downloadContentError));
        }
    };
};

const downloadContentRequest = (contentId, contentType) => {
    return {
        type: DOWNLOAD_CONTENT_REQUEST,
        contentId: contentId,
        contentType: contentType
    };
};

const downloadContentSuccess = (payload) => {
    return {
        type: DOWNLOAD_CONTENT_SUCCESS,
        payload
    };
};

const downloadContentError = (errorMessage) => {
    return {
        type: DOWNLOAD_CONTENT_ERROR,
        errorMessage
    };
};